export default __webpack_public_path__ + "aabba7a7c413dc690564e01483a604f8.png";